export {
	default as AdminManagementLayout,
	AdminManagementLayoutLoader,
} from './admin-management-layout';
